import { Maybe, TowingOrderStatus, User } from '../../common/types'
import { TowingOrder } from '../../containers/TowingOrderPage/ViewTowingOrder/types'
import { TowingRecord } from '../../containers/TowingRecordPage/ViewTowingRecord/types'

const SEND_SMS_ORDER_STATUSES: TowingOrderStatus[] = [
  TowingOrderStatus.pending_acceptance,
  TowingOrderStatus.open,
  TowingOrderStatus.assigned,
  TowingOrderStatus.accepted,
  TowingOrderStatus.towing_record_created,
  TowingOrderStatus.cancelled,
]

export function canShowSendSmsOnOrder(
  user: Maybe<User>, 
  towingOrder: TowingOrder
): boolean {
  
  if (!user || towingOrder.locked) {
    return false
  }

  return SEND_SMS_ORDER_STATUSES.includes(towingOrder.status)
}

export function canShowSendSmsOnRecord(
  user: Maybe<User>,
  towingRecord: TowingRecord,
  lockedFor: Maybe<string>
): boolean {

  return !!user && !!towingRecord.id && !lockedFor
}
